import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { SuperGif } from '@wizpanda/super-gif';

@Component({
  selector: 'app-gifdialog',
  templateUrl: './gifdialog.component.html',
  styleUrls: ['./gifdialog.component.css']
})
export class GifdialogComponent {

  constructor( public dialogRef: MatDialogRef<GifdialogComponent>, private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
      public data: any
    ) { }

    public output:String;
    public stepone:Boolean;
    public firstFormGroup: FormGroup;
    public secondFormGroup: FormGroup;
    public superGif: SuperGif;

    onNoClick(): void {
      this.dialogRef.close();
    }
  ngOnInit() {
    // will log the entire data object
    // console.log(this.data)
    // console.log("INITTED");
    let elements = Array.from(document.getElementsByClassName("super-gif"));
      console.log("TRYING", elements);
    elements.forEach(function (img_tag) {
      console.log("TRYING");
      console.log("SRC", img_tag);
				// if (/.*\.gif/.test(img_tag.src)) {
				// 	var rub = new SuperGif({ gif: img_tag }, {autoplay: 1} );
				// 	rub.load(function(){
				// 		console.log('oh hey, now the gif is loaded');
				// 	});
				// }
			});

    this.output = this.data.output;
    this.stepone = this.data.stepone;

    this.firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', Validators.required]
  });
  this.secondFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required]
  });
  }

}
